// import external dependencies
import 'jquery';
import SimpleLightbox from 'simplelightbox';
const slb = new SimpleLightbox('.lightbox');

// Import everything from autoload
import './autoload/_foundation.js'

// Import Slick
import 'slick-carousel/slick/slick';


import 'foundation-sites/js/foundation';
import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
const drilldownOptions = {
  animateHeight: true,
  autoHeight: true,
}
const myDrilldownElement = $('.mobile-nav .menu');
const mobileDrilldown = new Drilldown(myDrilldownElement, drilldownOptions);


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  slb,

  mobileDrilldown,
});

$('.close-nav-button, .mobile-nav-trigger').click(function(){
  $('.mobile-nav').toggle();
});

$('.mobile-nav').toggle().addClass('remove-opacity');

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js